
export default function Features() {
  const features = [
    {
      title: 'Fast Performance',
      description: 'Experience lightning-fast speeds with optimized code and efficient resource management. Our applications are built to deliver instant responses and smooth interactions.',
      icon: 'ri-flashlight-line',
      gradient: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)'
    },
    {
      title: 'Secure Encryption',
      description: 'Your data is protected with military-grade encryption protocols. We implement the latest security standards to ensure your information remains private and secure.',
      icon: 'ri-lock-line',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)'
    },
    {
      title: 'Easy Interface',
      description: 'Intuitive design that anyone can use. Our user-friendly interfaces are crafted with simplicity in mind, making powerful features accessible to everyone.',
      icon: 'ri-hand-heart-line',
      gradient: 'linear-gradient(135deg, #10b981 0%, #14b8a6 100%)'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900">Key Features</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div
                className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
                style={{ background: feature.gradient }}
              >
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
